import { firestore } from 'firebase'

export const CountMonths = (startDate: firestore.Timestamp, endDate: firestore.Timestamp) => {
  let months = (endDate.toDate().getFullYear() - startDate.toDate().getFullYear()) * 12
  months -= startDate.toDate().getMonth()
  months += endDate.toDate().getMonth()

  return months <= 0 ? 0 : months
}
